import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { clearLastOrganization } from '@/shared/utils/organization-route';

// Algumas escritas precisam preservar o diálogo e apresentar a negativa de contexto da API.
export const HANDLE_AUTH_ERROR_LOCALLY = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = localStorage.getItem('accessToken');

  let newReq = req;

  if (token) {
    newReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  return next(newReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.context.get(HANDLE_AUTH_ERROR_LOCALLY)) {
        console.warn('Sessão expirada ou inválida. Redirecionando...');
        localStorage.removeItem('accessToken');
        clearLastOrganization();
        router.navigate(['/']);
      }

      return throwError(() => error);
    }),
  );
};
